import { styled } from '@grupoboticario/flora-react';

export default {
  Wrapper: styled('div', {
    background: '$light-dark-1',
    height: '100%',
    left: '0',
    position: 'fixed',
    top: '0',
    width: '100%',
    zIndex: '99999',
  }),

  WrapperImage: styled('div', {
    height: 'calc(100% - 48px)',
    left: '0',
    overflow: 'auto',
    position: 'absolute',
    textAlign: 'center',
    top: '0',
    whiteSpace: 'nowrap',
    width: '100%',
    zIndex: '1',

    img: {
      display: 'inline-block',
      height: 'auto',
      width: '200%',
    },

    '@mobile': {
      img: {
        width: '100%',
      },
    },

    '@tablet': {
      img: {
        width: '50%',

        '&:last-child': {
          display: 'inline-block',
        },
      },
    },

    variants: {
      contrast: {
        true: {
          filter: 'grayscale(100%)',
        },
      },
      isDesktop: {
        true: {
          cursor: 'zoom-out',
        },
      },
    },
  }),

  Navigation: styled('nav', {
    alignItems: 'center',
    background: '$light-dark-1',
    bottom: '0',
    display: 'flex',
    height: '48px',
    left: '0',
    position: 'absolute',
    width: '100%',
    zIndex: '9',
  }),

  Close: styled('button', {
    alignItems: 'center',
    background: '$light-light',
    borderRadius: '$pill',
    border: 'none',
    color: '$actionNavigationStandardStatic',
    display: 'flex',
    height: '32px',
    justifyContent: 'center',
    lineHeight: 'normal',
    padding: '0',
    position: 'absolute',
    right: '$3',
    top: '$3',
    width: '32px',
    zIndex: '5',
  }),
};
